import React, { useEffect, useState } from "react";
import "./Analytics.scss";

import { FaAngleDown } from "react-icons/fa6";

import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import CalenderOptions from "../../constants/calenderFilterOptions";
import { Outlet, useNavigate } from "react-router-dom";
import { loadAnalyticsIfNeeded } from "../../redux/features/analytics-slice";
import Loader from "../../components/Loader/Loader";
import { toast } from "react-toastify";
import ROUTES from "../../constants/routes";

import RevenueAnalytics from "./Revenue/RevenueAnalytics";
import SalesAnalytics from "./Sales/SalesAnalytics";
import ProductAnalytics from "./Products/ProductAnalytics";
import CategoryAnalytics from "./Categories/Categories";
import PaymentAnalytics from "./Payment/PaymentAnalytics";
import BranchAnalytics from "./Branch/BranchAnalysts";
import SalesByStaffAnalytics from "./SalesByStaff/SalesByStaffAnalytics";
import SalesByCustomerAnalytics from "./SalesByCustomer/SalesByCustomerAnalytics";
import useUserIsAllowed from "../../helpers/userAuthorized";
import { IoIosArrowBack } from "react-icons/io";
import { updateOpenSubscriptionAd } from "../../redux/features/subscription-slice";
import useOrganizationIsAllowed from "../../helpers/organizationPrevillages";
import { LuCalendar } from "react-icons/lu";
import CustomButton from "../../components/CustomButton/CustomButton";

const Analytics = () => {
  const { id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );
  const { id: branch_id, branches } = useSelector(
    (state) => state.branchReducer.value
  );

  const { is_admin, id: user_id } = useSelector(
    (state) => state.userReducer.value
  );

  const { revenueAnalytics, loading, lastParams } = useSelector(
    (state) => state.analyticsReducer
  );

  const orgIsAllowedToViewAnalytics = useOrganizationIsAllowed("analytics");

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const finalCalenderOptions = [
    { label: "Date Range", value: "start_end_date" },
    ...CalenderOptions,
  ];
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});

  const [selectedTab, setSelectedTab] = useState("");
  const [reload, setReload] = useState(true);
  const [selectedDesktopTab, setSelectedDesktopTab] = useState("Revenue");
  const filter_tag = lastParams?.filter_type || "last_30_days";
  const last30days = finalCalenderOptions.find((el) => el.value === filter_tag);
  const [selectedCalenderFilter, setSelectedCalenderFilter] =
    useState(last30days);

  const [previousSelectedCalenderFilter, setPreviousSelectedCalenderFilter] =
    useState(last30days);

  const [dates, setDates] = useState({
    start_date: lastParams?.start_date || null,
    end_date: lastParams?.end_date || null,
  });

  const getBranchesOptions = () => {
    let optionsData = [
      {
        label: "All Branches",
        value: "none",
      },
    ];
    branches?.map((item) => {
      const option = {
        label: `${item?.name}`,
        value: item?.id,
      };
      optionsData.push(option);
    });

    setSelectOptions(optionsData);
    const branchTag = lastParams?.branch_id || "none";
    const selected = optionsData.find((el) => el.value === branchTag);
    setSelectedOption(selected || {});
  };

  useEffect(() => {
    getBranchesOptions();
  }, [branches]);

  const userIsAllowedToViewAnalytics = useUserIsAllowed("view_analytics");

  useEffect(() => {
    if (user_id) {
      if (is_admin || userIsAllowedToViewAnalytics) {
        if (selectedCalenderFilter?.value && selectedOption?.value) {
          dispatch(
            loadAnalyticsIfNeeded({
              organization_id: organization_id,
              branch_id: selectedOption?.value || "none",
              filter_type: selectedCalenderFilter?.value || "",
              start_date: dates?.start_date || "",
              end_date: dates?.end_date || "",
            })
          );
        }
        setSelectedTab("");
      } else {
        toast.dismiss();
        toast.info("User unauthorized to use this page!");
        navigate(ROUTES.home.path);
      }
    }
  }, [
    organization_id,
    selectedOption,
    selectedCalenderFilter,
    user_id,
    is_admin,
    reload,
  ]);

  useEffect(() => {
    if (selectedTab === "calender") {
      setDates({
        start_date: lastParams?.start_date || null,
        end_date: lastParams?.end_date || null,
      });
      setPreviousSelectedCalenderFilter(selectedCalenderFilter);
    }
  }, [selectedTab]);

  const handleDateChange = (e) => {
    if (previousSelectedCalenderFilter !== finalCalenderOptions[0]) {
      setPreviousSelectedCalenderFilter(finalCalenderOptions[0]);
    }
    const { name, value } = e.target;
    setDates({ ...dates, [name]: value });
  };

  const handleChangeDateFilter = () => {
    if (
      previousSelectedCalenderFilter?.value ===
        finalCalenderOptions[0]?.value &&
      dates.start_date &&
      dates.end_date
    ) {
      setSelectedCalenderFilter(finalCalenderOptions[0]);
    } else if (
      previousSelectedCalenderFilter?.value !==
        finalCalenderOptions[0]?.value &&
      previousSelectedCalenderFilter.value !== selectedCalenderFilter.value
    ) {
      setDates({
        start_date: null,
        end_date: null,
      });
      setSelectedCalenderFilter(previousSelectedCalenderFilter);
    }
    setReload((pre) => !pre);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="page-with-side-components reverse">
        <div className="analytics-page">
          <div className="desktop-navbar">
            <p>{ROUTES.analytics.title}</p>
          </div>
          <div className="topbar customPerPageTopBar">
            <div
              className="left"
              onClick={() => {
                setSelectedTab("");
              }}
            >
              <CustomSelect
                options={selectOptions}
                value={selectedOption}
                register={() => {}}
                required={true}
                name="isHighlight"
                handleChange={(opt) => {
                  setSelectedOption(opt);
                  setSelectedTab("");
                }}
                reset={() => {}}
              />
            </div>
            <div
              className={`right ${selectedTab === "calender" ? "active" : ""}`}
              onClick={() => {
                if (selectedTab === "calender") {
                  setSelectedTab("");
                } else {
                  setSelectedTab("calender");
                }
              }}
            >
              <div className="content">
                <span>
                  Best day: {revenueAnalytics?.best_day_for_revenue || "N/A"}
                </span>
                <p>{selectedCalenderFilter?.label}</p>
              </div>
              <FaAngleDown />
            </div>
          </div>

          <div
            className={`calender-filter ${
              selectedTab === "calender" ? "active" : ""
            }`}
          >
            <div className="top">
              <div
                className="back"
                onClick={() => {
                  setSelectedTab("");
                }}
              >
                <IoIosArrowBack />
              </div>
              <p>Date Filter</p>
            </div>

            <p className="heading">
              <LuCalendar /> Date Range
            </p>

            <div className="date-range">
              <div className="date-input">
                <input
                  type="date"
                  name="start_date"
                  value={dates.start_date}
                  onChange={(e) => {
                    if (orgIsAllowedToViewAnalytics?.exists) {
                      handleDateChange(e);
                    } else {
                      dispatch(updateOpenSubscriptionAd({ openAd: true }));
                    }
                  }}
                />
                <p>{dates.start_date || "Start Date"}</p>
              </div>
              <p>to</p>
              <div className="date-input">
                <input
                  type="date"
                  name="end_date"
                  value={dates.end_date}
                  onChange={(e) => {
                    if (orgIsAllowedToViewAnalytics?.exists) {
                      handleDateChange(e);
                    } else {
                      dispatch(updateOpenSubscriptionAd({ openAd: true }));
                    }
                  }}
                />
                <p>{dates.end_date || "End Date"}</p>
              </div>
            </div>

            <div className="list">
              {CalenderOptions.map((el, i) => {
                return (
                  <div
                    className={`item ${
                      previousSelectedCalenderFilter?.value === el.value
                        ? "active"
                        : ""
                    }`}
                    key={i}
                    onClick={() => {
                      if (
                        el?.value !== "last_30_days" &&
                        !orgIsAllowedToViewAnalytics?.exists
                      ) {
                        dispatch(updateOpenSubscriptionAd({ openAd: true }));
                      } else {
                        setPreviousSelectedCalenderFilter(el);
                        setDates({
                          start_date: null,
                          end_date: null,
                        });
                      }
                    }}
                  >
                    {el.label}
                  </div>
                );
              })}
            </div>

            <div className="buttons">
              <CustomButton
                name={"Done"}
                color={"primary"}
                type={"button"}
                handleSubmit={() => {
                  handleChangeDateFilter();
                }}
                bigButton={true}
                disabled={false}
              />
            </div>
          </div>
          <Outlet context={{ setSelectedDesktopTab, selectedDesktopTab }} />
        </div>
        <div className="right-desktop-view analytic-right-view">
          <div className="desktop-navbar border-bottom">
            <p className="center">{selectedDesktopTab}</p>
          </div>

          {selectedDesktopTab === "Revenue" && <RevenueAnalytics />}
          {selectedDesktopTab === "Sales" && <SalesAnalytics />}
          {selectedDesktopTab === "Products" && <ProductAnalytics />}
          {selectedDesktopTab === "Categories" && <CategoryAnalytics />}

          {selectedDesktopTab === "Payment Methods" && <PaymentAnalytics />}
          {selectedDesktopTab === "Branches" && <BranchAnalytics />}
          {selectedDesktopTab === "Staffs" && <SalesByStaffAnalytics />}
          {selectedDesktopTab === "Customers" && <SalesByCustomerAnalytics />}
        </div>
      </div>
    </>
  );
};

export default Analytics;
